import { render, staticRenderFns } from "./ShippingDetailsForm.vue?vue&type=template&id=6b484d8d&scoped=true"
import script from "./ShippingDetailsForm.vue?vue&type=script&lang=js"
export * from "./ShippingDetailsForm.vue?vue&type=script&lang=js"
import style0 from "./ShippingDetailsForm.vue?vue&type=style&index=0&id=6b484d8d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b484d8d",
  null
  
)

export default component.exports